import PropTypes from 'prop-types'
import React, { useEffect } from "react"
import { connect } from "react-redux"

import { logoutUser } from "../../store/actions"
import { useNavigate } from 'react-router'

const Logout = props => {
  const navigate = useNavigate();

  useEffect(() => {
    props.logoutUser(navigate)
  })

  return <></>
}

Logout.propTypes = {
  history: PropTypes.object,
  logoutUser: PropTypes.func
}

export default connect(null, { logoutUser })(Logout)
